import axios from 'axios';
import { API_URL } from '../src/constants/urls';

export default {
    GetMLToken() {
        return axios({
            method: 'post',
            url: `${API_URL}get-token`,
            data: {
                key: 'wHjOKqH25WwOEeHphyGR',
                secret: '37m2LWciLhboNNFA6UkQ',
            },
        });
    },
    GetPost(token, barcode, startDate) {
        return axios({
            method: 'post',
            url: `${API_URL}posts/get`,
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            data: {
                barcode,
                withLogs: false,
                makeGroup: false,
                useForce: true,
                startDate
            },
        });
    },
    GetGetHandshakeDetail(token, handshakeID) {
        return axios({
            method: 'post',
            url: `${API_URL}flow/get-handshake-by-id`,
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            data: {
                handshakeID
            },
        });
    }
};
